import { Level, SignupScreen, UserProfile } from 'fitbeat.gym-core';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { Text, View } from 'react-native';
import { connect } from 'react-redux';
import { SelectionContainer } from '../Bookings/components/SelectionContainer';
import { IAppStore } from '../HomeWorkouts';
import { GoogleAnalytics } from '../services/google-analytics';
import Theme , { ThemeType } from '../theme';
import { UserDataConsumer } from '../utils';
import { defaultScale, scaleText } from '../utils/scaling';
import { skillLevels } from '../utils/skillLevels';
import { getNextStep, navigateToNextStep } from './actions';
import { INavigateToNextStep } from './types';
import { sharedStyles } from './OnboardingSharedStyles';


interface IProps {
  userProfile: UserProfile;
  navigation: any;
  t(key: string): string;
  getNextStep(navigateToNextStep: INavigateToNextStep): void;
  navigateToNextStep(navigateToNextStep: any): void;
}

interface IState {
  level: Level;
}

class HomeSkillLevel extends PureComponent<IProps, IState> {
  public state = {
    level: null,
  };

  private googleAnalytics = new GoogleAnalytics();

  public setLevel = (level: Level) => {
    this.setState({ level });
  }

  public setLevelAndContinue = (level: Level) => {
    this.setState({ level });
    this.props.getNextStep({
      currentScreen: SignupScreen.SkillLevel,
      userProfile: { skillLevel: level },
    });
    this.props.navigateToNextStep(this.props.navigation);
    this.googleAnalytics.logEventWithParamaters('sign_up_skill_level', { level });
  }

  public render() {
    const { t } = this.props;
    const { level } = this.state;

    return (
      <View style={sharedStyles.container}>
        <Text
          style={[Theme.textStyle.heading, { marginBottom: defaultScale(6) }]}
        >
          {t('WhatIsYourSkillLevel')}
        </Text>
        <Text
          style={[
            Theme.textStyle.bodyCopyReg,
            { color: Theme.GREY_MEDIUM, marginBottom: 24 },
          ]}
        >
          {t('personalizeFitnessJourneySkill')}
        </Text>
        <View style={{ flex: 1, marginTop: defaultScale(10) }}>
          {skillLevels.map((skillLevel)=>{
            return  <SelectionContainer
            title={skillLevel.display}
            overrideLightStyles={{defaultSubtitleColor : Theme.GREY_MEDIUM}}
            subTitle={skillLevel.subtitle}
            style={sharedStyles.selectionContainer}
            titleStyle={sharedStyles.bookingSelectionTitle}
            subTitleStyle={sharedStyles.bookingSelectionSubtitle}
            isSelected={level === skillLevel.value }
            theme={ThemeType.light}
            onPress={() => this.setLevelAndContinue(skillLevel.value)}
            height={defaultScale(100)}
            width={'100%'}
          />
          })}
        </View>
      </View>
    );
  }
}


const mapStateToProps = (state: IAppStore): Partial<IProps> => {
  return {
    userProfile: state.auth.signup.userProfile,
  };
};

const mapDispatchToProps = {
  getNextStep,
  navigateToNextStep,
};

export const HomeSkillLevelScreen = translate(['auth'], { wait: true })(
  connect(mapStateToProps, mapDispatchToProps)(UserDataConsumer(HomeSkillLevel)),
);
